import { wishlistColors } from './relationshipConfig';

import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
export default function EditWishlistModal({ 
  isOpen, 
  wishlist,
  onClose, 
  onSubmit, 
  darkMode 
}) {
  if (!wishlist) return null;

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-md" style={{ backgroundColor: darkMode?.isDark ? '#2D4354' : 'white' }}>
        <DialogHeader>
          <DialogTitle style={{ fontFamily: 'Playfair Display, serif', color: darkMode?.isDark ? '#FED7A5' : '#20212B', fontSize: '24px' }}>
            Edit Wishlist
          </DialogTitle>
        </DialogHeader>

        <form onSubmit={onSubmit} className="space-y-5 mt-4">
          <div>
            <Label style={{ color: darkMode?.isDark ? '#FED7A5' : '#20212B' }}>
              Wishlist Name
            </Label>
            <Input
              type="text"
              name="name"
              defaultValue={wishlist.name}
              placeholder="e.g., Holiday 2025, Birthday Ideas"
              className="mt-1"
              style={{
                backgroundColor: darkMode?.isDark ? 'rgba(255, 255, 255, 0.1)' : 'white',
                color: darkMode?.isDark ? '#FED7A5' : '#1F2937',
                border: `1px solid ${darkMode?.isDark ? '#FED7A5' : '#E5E5E5'}`
              }}
              required
            />
          </div>

          <div>
            <Label style={{ color: darkMode?.isDark ? '#FED7A5' : '#20212B' }}>
              Choose Color
            </Label>
            <div className="grid grid-cols-4 gap-3 mt-2">
              {wishlistColors.map((color) => (
                <label key={color.value} className="relative">
                  <input
                    type="radio"
                    name="color"
                    value={color.value}
                    defaultChecked={wishlist.color === color.value}
                    className="sr-only peer"
                  />
                  <div
                    className="w-9 h-9 rounded-full cursor-pointer transition-all hover:scale-110 peer-checked:ring-4 peer-checked:ring-offset-2"
                    style={{
                      backgroundColor: color.value,
                      border: '2px solid transparent',
                      boxShadow: 'none'
                    }}
                    title={color.name}
                  />
                </label>
              ))}
            </div>
          </div>

          <div className="flex gap-3 pt-4">
            <Button
              type="button"
              onClick={onClose}
              variant="outline"
              className="flex-1"
              style={{ 
                borderColor: darkMode?.isDark ? '#FED7A5' : '#E5E5E5',
                color: darkMode?.isDark ? '#FED7A5' : '#534145'
              }}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              className="flex-1 transition-all hover:scale-[1.02]"
              style={{ background: '#9E6752', color: 'white' }}
            >
              Save Changes
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
